enum pwdRecoveryStatusEnum {
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
	PASSWORD_RESET = 'PASSWORD_RESET',
	MFA_CHALLENGE = 'MFA_CHALLENGE'
}

export default pwdRecoveryStatusEnum